<template>
  <multiselect
      v-model="selectedItems"
      @update:modelValue="onSelectItems"
      :options="optionsList"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content task-tag-types-select"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
      :allow-empty="true"
  >
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <input
            type="checkbox"
            :checked="isItemChecked(props.option.value)"
            @focus.prevent
            :key="props.option.value"
        />
        <span class="option__title">{{ $t(props.option.translationKey) }}</span>
      </div>
    </template>
    <template #beforeList v-if="optionsList.length > 0">
      <li class="multiselect__element" @click="toggleAllItemsSelection">
        <span class="multiselect__option tracking-multiselect-with-checkbox">
          <input type="checkbox" :checked="areAllItemsSelected()" @focus.prevent>
          <span class="option__title"><b>{{ $t('settings.generic.select-all') }}</b></span>
        </span>
      </li>
    </template>
    <template #selection="{ values, isOpen }">
      <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
        {{ $t('settings.generic.selected-items') }} {{ values.length }}
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import {TaskTagType} from "@/assets/js/enums/TaskTagType.ts";

export default {
  name: "ChooseTaskTagType",
  components: {Multiselect},
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    includeOazisIntegration: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItems: Array.isArray(this.modelValue) ? this.modelValue : []
    };
  },
  computed: {
    optionsList() {
      return TaskTagType.all()
          .filter(x => this.includeOazisIntegration || x.value !== TaskTagType.OazisIntegration);
    }
  },
  watch: {
    modelValue(value) {
      this.selectedItems = this.getAllowedSelectedItems(value);
    },
    includeOazisIntegration() {
      const selectedItems = this.getAllowedSelectedItems(this.selectedItems);
      this.onSelectItems(selectedItems);
    }
  },
  mounted() {
    this.onSelectItems(this.selectedItems, false);
  },
  methods: {
    onSelectItems(data, triggerValueUpdate = true) {
      this.selectedItems = this.getAllowedSelectedItems(data ?? []);
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', this.selectedItems);
      }
    },
    areAllItemsSelected() {
      return (this.selectedItems?.length ?? 0) === this.optionsList.length;
    },
    isItemChecked(value) {
      return (this.selectedItems ?? []).some(x => x?.value === value);
    },
    toggleAllItemsSelection() {
      this.onSelectItems(this.areAllItemsSelected() ? [] : this.optionsList);
    },
    getAllowedSelectedItems(items) {
      const selectedItems = Array.isArray(items) ? items : [];
      const allowedValues = this.optionsList.map(x => x.value);

      return selectedItems.filter(x => allowedValues.includes(x?.value));
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.task-tag-types-select {
  width: 220px;
}

@media (max-width: $breaking-point) {
  .task-tag-types-select {
    width: 100%;
  }
}
</style>
